import { render, staticRenderFns } from "./TranscriptInput.vue?vue&type=template&id=21fd162b"
import script from "./TranscriptInput.vue?vue&type=script&lang=js"
export * from "./TranscriptInput.vue?vue&type=script&lang=js"
import style0 from "./TranscriptInput.vue?vue&type=style&index=0&id=21fd162b&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports